module.exports = __webpack_public_path__ + "static/img/four.2f89bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newNmg/four.png
// module id = aUJ0
// module chunks = 1